import './StepBox.scss';
import arrowIcon from '@assets/svg/arrow.svg';

interface AIProps {
  className?: string;
}

export const ArrowIcon = ({ className }: AIProps) => <img src={arrowIcon} className={`arrow-icon`} />;
